//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



export default {
    components: {
    },
    props: {
        description: String,
        zones: Array,
        ranking_types: Object,
        types: Array,
        type: String,
        zone: String,
        show_empty: Boolean,
        show_recommend: Boolean,
        recomend_type: String,
        loading: Boolean
    },
    data () {
        return {
            select_show: false
        }
    },
    methods: {
        toggleSelect () {
            this.select_show = !this.select_show
        }
    }
}
